import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    //Tooltip,
    Button,
    styled,
    Icon,
    Table, TableBody, TableCell, TableContainer, TableFooter,
    TableHead, TableRow,
    tableCellClasses,
    Collapse,
    LinearProgress,
    IconButton,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
//import clsx from 'clsx';
/////import FileSaver from "file-saver";
//import XLSX from "sheetjs-style-v2"
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Loading } from "../../shered/components/loading/Loading";
import { IDetalheHistoricoFinanceiroUsuario, IHistoricoFinanceiroUsuario, RelatorioService } from "../../shered/services/api/relatorio/RelatorioService";

import dayjs from "dayjs";
import { UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: UtilidadeService.isMobile() ? "5px" : "5px",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: UtilidadeService.isMobile() ? "5px" : "5px",
        fontWeight: "bold"

    },
    [`&.${tableCellClasses.footer}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: UtilidadeService.isMobile() ? "8px 5px" : "8px 5px",
        fontWeight: "bold"
    }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td': {
        border: 0,
    },
    '&:last-child th': {
        border: 0,
        padding: UtilidadeService.isMobile() ? "8px 5px" : "10px 8px",
    },
    '&:nth-of-type(odd):hover': {
        backgroundColor: "#fbc02d",
        fontWeight: "bold"
    },
    '&:nth-of-type(even):hover': {
        backgroundColor: "#fbc02d",
        fontWeight: "bold"
    },
}));

const StyledTableCellCollapse = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#252525",
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: "5px",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: "5px",
        fontWeight: "bold"
    },
    [`&.${tableCellClasses.footer}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    }
}));

const StyledTableRowCollapse = styled(TableRow)(({ theme }) => ({
    '&:last-child th': {
        border: 0,
        padding: "5px",
    },
}));


export const ListagemDeHistoricoFinanceiroUsuarios: React.FC = () => {
    const theme = useTheme();
    //const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [dadosRelRows, setDadosRelRows] = useState<IHistoricoFinanceiroUsuario[]>([]);
    const [detalhesRelRows, setDedtalhesRelRows] = useState<IDetalheHistoricoFinanceiroUsuario[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [usuarioFiltro, setUsuarioFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstUsuario, setLstUsuario] = useState<ILstDrop[]>([]);
    const [openR, setOpenR] = useState<boolean>(false);
    const [ltsCodigoOpenR, setLstCodigoOpenR] = useState<number[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);


    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UsuarioService.getAll()
                    .then((result) => {
                        const usu = result.data.dado;
                        let lstUsuAux = usu.filter(f => !f.administrador).sort((a, b) => a.nome > b.nome ? 1 : -1).map((f, i) => ({ codigo: f.codigo, label: f.nomeSobrenome }));
                        setLstUsuario(lstUsuAux);
                        carregarDadosRelatorio(0);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });
            })
        }
    }, []);

    const carregarDadosRelatorio = (codigoUsuario: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        RelatorioService.getRelFinanceiroUsuario(codigoUsuario)
            .then((result) => {
                const lstDados = result.dado;
                setDadosRelRows(lstDados); //.sort((a, b) => a.nome_Usuario > b.nome_Usuario ? 1 : -1));
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedUsuario = async (e: { target: { name: string; value: any; }; }) => {
        setUsuarioFiltro(e.target.value);
        setDadosRelRows([]);
        carregarDadosRelatorio(Number(e.target.value));

    }


    // const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml,sheet;charser=UTF-8";
    // const fileExtension = ".xlsx";
    // const exportToExcel = async (dados: IDetalheRelatorioLigasUsuario[]) => {
    //     let lstExcel: IDetalheRelatorioLigasUsuario[] = [];
    //     // dados.forEach(f => {
    //     //     const dadosExcel: IDetalheRelatorioPagamentoPendente = {
    //     //         nome_Completo: f.nome_Completo,
    //     //         cpf: f.cpf.length > 1 ?  maskCPF(f.cpf) : "-",
    //     //         telefone: `(${f.ddD_Telefone}) ${f.telefone}`,
    //     //         email: f.email,
    //     //         parcela: f.parcela === 1 ? "Matricula" : `Parcela ${f.parcela - 1}`,
    //     //         data_Pagamento: f.data_Pagamento !== "0001-01-01T00:00:00" ?  dayjs(f.data_Pagamento).format("DD/MM/YYYY") : "-",
    //     //         forma_Pagamento: formasPagamento.find(j => j.codigo === f.codigo_Forma_Pagamento)?.label,
    //     //         valor: formatNumber.format(f.valor),
    //     //         cidade: f.endereco.cidade,
    //     //         estado: f.endereco.estado,
    //     //         sigla: f.endereco.sigla,
    //     //         bairro: f.endereco.bairro,
    //     //         logradouro: f.endereco.logradouro,
    //     //         numero: f.endereco.numero,
    //     //         complemento: f.endereco.complemento,
    //     //         cep: f.endereco.cep !== undefined ? maskCEP(f.endereco.cep) : "-",
    //     //         codigo_Situacao: f.codigo_Situacao,
    //     //         data_Vencimento: dayjs(f.data_Vencimento).format("DD/MM/YYYY") ,
    //     //         situacao: codigoSituacaoFiltro === 6 ? statusFinanceiro.find(s => s.codigo === codigoSituacaoFiltro)?.label : statusFinanceiro.find(s => s.codigo === f.codigo_Situacao)?.label


    //     //     }
    //     //     lstExcel.push(dados);
    //     // })

    //     setIsLoading(true);
    //     setRemoveLoading(false);
    //     const ws = XLSX.utils.json_to_sheet(dados);
    //     const wb = { Sheets: { "data": ws }, SheetNames: ["data"] };
    //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    //     const data = new Blob([excelBuffer], { type: fileType });
    //     FileSaver.saveAs(data, `Recebimento_Faturamento_${dayjs().format("DD/MM/YYYY")}.${fileExtension}`);
    //     setIsLoading(false);
    //     setRemoveLoading(true);
    // }

    const handleLimpar = () => {
        setUsuarioFiltro(0);
        carregarDadosRelatorio(0);
    }

    const handleClickOpenDetalhes = async (codigo: number) => {
        //setOpenR(!openR)

        //setLstCodigoOpenR(ltsCodigoOpenR.length > 0 ? ltsCodigoOpenR.filter(f => f === codigo).length > 0 ?
        //   ltsCodigoOpenR.filter(f => f !== codigo) : [...ltsCodigoOpenR, codigo] : [codigo]);

        await carregarDetalhesRelatorio(codigo);
    }

    const carregarDetalhesRelatorio = async (codigoUsuario: number) => {        
         if(openR){
            setDedtalhesRelRows([]);
            setOpenR(!openR);
            return;
         }

        await RelatorioService.getRelDetalhesFinanceiroUsuario(codigoUsuario)
            .then((result) => {
                const lstDados = result.dado;
                setDedtalhesRelRows(lstDados);
                // setIsLoading(false);
                // setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }


    const handleOpen = (index: number, codigo: number) => {      
        carregarDetalhesRelatorio(codigo);
    };

    return (
        <LayoutBaseDePagina
            titulo={`Relatório Pagamento Pendente`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Relatório Financeiro Usuários </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Usuários</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={usuarioFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedUsuario)}
                                            defaultValue={0}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstUsuario.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                {(usuarioFiltro > 0) && (
                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} marginTop={2} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            disableElevation
                                            onClick={() => handleLimpar()}
                                            endIcon={<Icon>clear</Icon>}>
                                            Limpar Filtro
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            {/* <Grid size={{ xs: 12, sm: 10 }} display={"flex"} justifyContent="flex-end">
                                {dadosRelRows.length > 0 && (
                                    <Tooltip title="Exportar Time">
                                        <Button variant="outlined"
                                            onClick={() => exportToExcel(dadosRelRows)} color="primary"
                                            style={{ cursor: "pointer", height: "48px" }}
                                            endIcon={<GridSaveAltIcon />}
                                        >
                                            Exportar Relatório
                                        </Button >
                                    </Tooltip>
                                )}
                            </Grid> */}
                            {!removeLoading && <Loading />}
                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="row" display={"grid"} padding={1} spacing={2}>
                                <Grid container size={12} height="auto" display="flex" justifyContent="center" paddingTop={2} style={{ width: "100%" }}  >
                                    <Grid size={12} >
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>
                                            RECEITA
                                        </Typography>
                                    </Grid>
                                    <Grid size={12} >
                                        <TableContainer component={Paper} variant="outlined" sx={{ width: "auto" }}>
                                            <Table >
                                                <TableHead>
                                                    <StyledTableRow key={"m1"}>
                                                        <StyledTableCell></StyledTableCell>
                                                        <StyledTableCell>USUÁRIO</StyledTableCell>
                                                        <StyledTableCell align="center">E-MAIL</StyledTableCell>
                                                        <StyledTableCell align="right">TELEFONE</StyledTableCell>
                                                        <StyledTableCell align="right">DATA CADASTRO</StyledTableCell>
                                                        <StyledTableCell align="right">VALOR PAGO</StyledTableCell>

                                                    </StyledTableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {dadosRelRows.map((row, index) => (
                                                        <>
                                                            <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                                <StyledTableCell>
                                                                    <IconButton
                                                                        aria-label="expand row"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpenR(!openR);
                                                                            carregarDetalhesRelatorio(Number(row.codigo));

                                                                        }}
                                                                    >
                                                                        {detalhesRelRows.length > 0 ? detalhesRelRows.filter(f=> f.codigo_Usuario === row.codigo).length > 0 ? <KeyboardArrowUp sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 20 }} /> : <KeyboardArrowDown sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 20 }} /> : <KeyboardArrowDown sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 20 }} />}
                                                                    </IconButton>
                                                                </StyledTableCell>
                                                                <StyledTableCell component="th"
                                                                    onClick={() => { carregarDetalhesRelatorio(Number(row.codigo));}}>
                                                                    {row.nome}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center" component="th"
                                                                    //onClick={() => { setOpenR(prev => !prev); }}
                                                                    >
                                                                    {row.email}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center" component="th"
                                                                    //onClick={() => { setOpenR(prev => !prev); }}
                                                                    >
                                                                    {row.telefone}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center" component="th"
                                                                    //onClick={() => { setOpenR(prev => !prev); }}
                                                                    >
                                                                    {dayjs(row.data_Cadastro).format("DD/MM/YYYY")}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="right">{formatNumber.format(Number(row.valor_Total_Pago))}</StyledTableCell>
                                                            </StyledTableRow>
                                                            <StyledTableRow sx={{ visibility: detalhesRelRows.length > 0 ? detalhesRelRows.filter(f=> f.codigo_Usuario === row.codigo).length > 0 ? 'visible' : 'collapse' : 'collapse' }}>
                                                                <StyledTableCell
                                                                    key={row.codigo}
                                                                    style={{ padding: 0 }}
                                                                    colSpan={detalhesRelRows.length + 5}
                                                                >
                                                                    <Collapse in={detalhesRelRows.length > 0 ? detalhesRelRows.filter(f=> f.codigo_Usuario === row.codigo).length > 0 ? true : false : false} timeout="auto" unmountOnExit>
                                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 0, width: "auto" }}>
                                                                            <Table key={`Table${index}`} size="small" aria-label="purchases">
                                                                                {detalhesRelRows.map((rowIn, i) => (
                                                                                    <TableHead key={`Head${rowIn.codigo_Financeiro}`} sx={{ display: i === 0 ? "contents" : "none" }}>
                                                                                        <TableRow>
                                                                                            <StyledTableCellCollapse align="center">#</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse align="center">TEMPORADA</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse align="left">LIGA</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse align="right">VALOR</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse align="center">SITUAÇÃO</StyledTableCellCollapse>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                ))
                                                                                }
                                                                                {detalhesRelRows.map((rowIn, index2) => (
                                                                                    <TableBody key={index2}>
                                                                                        <StyledTableRowCollapse key={`Collapse${rowIn.codigo_Financeiro}`} >
                                                                                            <StyledTableCellCollapse size="small" align="center"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}

                                                                                            >{rowIn.codigo_Financeiro}</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse
                                                                                                align="center"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}
                                                                                            >{rowIn.descricao_Temporada}</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse align="left"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}

                                                                                            >{rowIn.descricao_Liga}</StyledTableCellCollapse>
                                                                                            <StyledTableCellCollapse
                                                                                                align="right"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}
                                                                                            >{formatNumber.format(Number(rowIn.valor))}</StyledTableCellCollapse>
                                                                                            {/* <StyledTableCellCollapse
                                                                                                align="right"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}
                                                                                            >{formatNumber.format(Number(rowIn.desconto))}</StyledTableCellCollapse> */}
                                                                                            <StyledTableCellCollapse
                                                                                                align="center"
                                                                                                sx={{
                                                                                                    cursor: "pointer",
                                                                                                    '&:nth-of-type(odd):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    },
                                                                                                    '&:nth-of-type(even):hover': {
                                                                                                        backgroundColor: "#b1b0b0",
                                                                                                        fontWeight: "bold"
                                                                                                    }
                                                                                                }}
                                                                                            >{rowIn.status}</StyledTableCellCollapse>
                                                                                        </StyledTableRowCollapse>
                                                                                    </TableBody>
                                                                                ))
                                                                                }
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Collapse>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        </>
                                                    ))
                                                    }
                                                </TableBody>
                                                {/* <TableFooter>
                                                    {isLoading && (
                                                        <TableRow>
                                                            <TableCell colSpan={100}>
                                                                <LinearProgress variant="indeterminate" />
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={3}>TOTAL</StyledTableCell>
                                                        <StyledTableCell colSpan={1} style={{ textAlign: "end", color: "white" }}>
                                                            {
                                                                formatNumber.format(Number(totalReceita))
                                                            }
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </TableFooter> */}
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


